import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Testimonials from './components/Testimonials';
import Services from './components/Services';
import Benefits from './components/Benefits';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="font-sans">
      <SeoJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <Testimonials />
        <Services />
        <Benefits />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
